import { Chip } from '@mui/material';
import React from 'react';
import { COLOR_GREY_200, COLOR_PRIMARY_2 } from 'src/utils/colors';

const AppliedFilterDisplayChip = ({
  chip,
  toggleDrawer,
  handleRemoveFilter,
}: {
  chip: any;
  toggleDrawer: () => void;
  handleRemoveFilter: (filterKey: string) => void;
}) => {
  return (
    <Chip
      label={chip.label}
      icon={chip.emoji}
      variant="filled"
      onClick={toggleDrawer}
      onDelete={() => handleRemoveFilter(chip.key)}
      sx={{
        backgroundColor: 'white',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        border: `2px solid ${COLOR_PRIMARY_2}`,
        '&:hover': {
          backgroundColor: COLOR_GREY_200,
        },
        fontWeight: 500,
        textTransform: 'capitalize',
      }}
    />
  );
};

export default AppliedFilterDisplayChip;
